<template>
  <div>
    <fixed-header title="Lookup Management" hideNewOfferBtn />
    <div class="animated fadeIn BillPayments--BillPayments-list">
      <div class="card">
        <div class="card-body d-flex flex-column">
          Select the Lookup table that you want to manage
          <b-form @submit="onSubmit">
            <b-row>
              <b-col cols="4">
                <b-form-group label="Lookup Table" class="mt-1" label-cols-sm="2" label-cols-lg="2">
                  <b-form-select @change="getLookupTableValues" v-model="formData.lookupTableId"
                                 :class="{ 'is-invalid': $v.formData.lookupTableId.$error }">
                    <option
                      v-for="(value, index) in sortSelect(tableList)"
                      :key="index"
                      :value="value.id"
                    >{{ value.name }}
                    </option>
                  </b-form-select>
                  <b-form-invalid-feedback>Please select lookup table.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
            <hr/>
            <b-row class="mb-2">
              <b-col cols="4">
                <b-form-group label="Value Name" class="required" label-cols-sm="2" label-cols-lg="2">
                  <b-form-input v-model="formData.name"
                                :class="{ 'is-invalid': $v.formData.name.$error }"></b-form-input>
                  <b-form-invalid-feedback>Value name is required</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col cols="2">
                <b-button v-if="((formData.id && checkClaim(CAN_EDIT_LOOKUP)) || (!formData.id && checkClaim(CAN_ADD_LOOKUP)))"
                          type="submit" variant="primary" class="btn-sm mr-2" :disabled="isSaving">
                  <i v-show="isSaving" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>Save</b-button>
                <b-button type="button" variant="secondary" class="btn-sm" @click="resetForm">Cancel</b-button>
              </b-col>
            </b-row>
          </b-form>
          <grid-component
            :gridId="gridId"
            :itemData="itemData"
            :fields="fields"
            :onDelete="onDelete"
            :handleRowClick="handleRowClick"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { required } from 'vuelidate/lib/validators';
  import FixedHeader from '@/shared/components/FixedHeader/indexNew';
  import GridSettings from '@/shared/components/GridSettings';
  import GridComponent from '@/shared/components/GridComponent';
  import fields from './fields';
  import service from './service';

  export default {
    components: {
      GridSettings,
      FixedHeader,
      GridComponent,
    },
    data() {
      return {
        fields,
        gridId: 'lookup-table',
        tableList: [],
        lookupTableValues: [],
        formData: {
          id: 0,
          lookupTableId: '',
          name: '',
          active: true,
        },
        isSaving:false
      };
    },
    metaInfo: () => ({
      title: 'Lookup Management',
    }),
    validations: {
      formData: {
        name: { required },
        lookupTableId: { required },
      },
    },
    computed: {
      itemData() {
        return this.lookupTableValues.map((lookup) => ({ ...lookup, selected: lookup.id === this.formData.id }));
      },
    },
    methods: {
      async onSubmit(evt) {
        evt.preventDefault();
        this.$v.formData.$touch();
        if (this.$v.formData.$invalid) {
          return;
        } else {
          try {
            this.isSaving = true;
            let id = await service.manageLookupTableValue(this.formData);
            this.isSaving = false;
            this.resetForm();
            if (id) {
              this.getLookupTableValues(this.formData.lookupTableId)
            }
          }catch (e) {
            this.isSaving = false;
          }
        }
      },
      resetForm() {
        this.formData = {
          id: 0,
          lookupTableId: this.formData.lookupTableId,
          name: '',
          active: true,
        };
        this.$v.$reset();
        this.$v.formData.$reset();
      },
      async getLookupTableValues(id) {
        this.resetForm();
        this.lookupTableValues = await service.getLookupTableValues(id);
        this.formData.lookupTableId = id;
      },
      handleRowClick(row) {
        this.formData.id = row.dataItem.id;
        this.formData.name = row.dataItem.name;
      },
      async onDelete(dto) {
        console.log(dto, "Dto")
        let response = await this.openConfirmBox({ message: `Are you want to delete the lookup value '${dto.name}'`});

        if (response)
        {
          await service.deleteLookupValue(dto.lookupTableId, dto.id).then((res) => {
            if (res.status == 200) {
              this.$snotify.success('Lookup deleted successfully');
              this.getLookupTableValues(dto.lookupTableId);
            }            
            
          });
        }
      }
    },
    async mounted() {
      this.tableList = await service.getLookupTables();
    },
  };
</script>

